export function getView(referral) {
  return referral?.person ? 'Preview' : 'SearchBar'
}
